// Feature flags. Defaults live here; each flag can be overridden per-browser
// via localStorage ("1" = on, "0" = off) for experimenting without a rebuild.
const readFlag = (key, defaultValue) => {
  try {
    const value = localStorage.getItem(key);
    if (value === "1") return true;
    if (value === "0") return false;
  } catch (e) {
    // localStorage unavailable — fall through to default
  }
  return defaultValue;
};

// Skeuomorphic drafting-table props: wood-grain board and masking-tape page
// corners. Off by default — the standard surface is a neutral matte board.
// Enable with: localStorage.setItem("striply_drafting_props", "1")
export const DRAFTING_TABLE_PROPS = readFlag("striply_drafting_props", false);
